import React, { FC } from "react";
import { KitContentsProps } from "../common/types";
import { Accordion } from "./Accordion";

export const KitContents: FC<KitContentsProps> = ({ items }) => {
  const list = items.map((item) => item?.title);
  return <Accordion title="In This Kit" list={list} />;
};
